import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CouponCodeService {

  constructor(private readonly _http: HttpClient) { }

    getCouponCode() {
      return this._http.get<any>(`${environment.endPoint}/api/CouponCode/Get`);
    }  
    updateCouponCode(data: any) {
      return this._http.post(`${environment.endPoint}/api/CouponCode/Update`, data);
    }
    AddCouponCode(data: any) {
      return this._http.post(`${environment.endPoint}/api/CouponCode/Create`, data);
    }
    UpdateCouponStatus(id: any, status: boolean) {
    return this._http.put(`${environment.endPoint}/api/CouponCode/UpdateCouponStatus?id=${id}&status=${status}`, null);
  }
}
